import api from '@/services/api/api';

export const useDateArticlesBySlug = (slug) => {
  const dateArticleSlug = useQuery(
    ['dateArticleSlug', slug],
    async () => {
      const { data } = await api.dates.getDateArticlesBySlug(slug);
      return data;
    },
    {
      enabled: computed(() => !!slug),
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await dateArticleSlug.suspense();
  });

  return {
    dateArticleSlug,
  };
};
